module.exports = __webpack_public_path__ + "img/icon_left2.91142683.png";